import { render } from "./EmployeeView25Liquidation.vue?vue&type=template&id=70f21e22"
import script from "./EmployeeView25Liquidation.vue?vue&type=script&lang=js"
export * from "./EmployeeView25Liquidation.vue?vue&type=script&lang=js"

import "./EmployeeView25Liquidation.vue?vue&type=style&index=0&id=70f21e22&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__